import React, { useState, useEffect } from 'react' 
import axios from "axios";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link , useNavigate} from 'react-router-dom';

export default function StaticList() {
  const nav = useNavigate()
  console.log('start now')
  const [staticList, setStaticContentList] = useState([]);
  useEffect(() => {
    getStaticContentList();
  }, []);

  const getStaticContentList = async () => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/admin/static-content-list",
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      }).then(function (response) {  
        //Check for Authorized
        if(response.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        console.log("response.data => ", response.data);
        setStaticContentList(response.data.data);
        
      }).catch(function (error) {        
        console.log(error);
      });
  };

  //initialize datatable
  useEffect(() => {
    setTimeout(function () {
      $("#myTable").DataTable({
        bDestroy: true,
        fixedHeader: true,
        pagingType: "full_numbers",
        pageLength: 10,
        processing: true,
        dom: "Bfrtip",
  
        select: true,
      });
    }, 1000);
  }, []);

    return (
    <div class="body flex-grow-1 px-3">
          <div className="wrapper">
            <div className="content-wrapper">
              <h5 className="my3">
                Static Content Management
              </h5>
              <table id="myTable" className="table table-striped my-3">
                <thead>
                  <tr>
                    <th scope="col" style={{"width" : "10%"}}>#</th>
                    <th scope="col" style={{"width" : "20%"}}>Key</th>
                    <th scope="col" style={{"width" : "60%"}}>Subject</th>
                    <th scope="col" style={{"width" : "10%"}}>Action(s)</th>
                  </tr>
                </thead>
                <tbody>
                  {staticList.map((value, index) => (
                    
                    <tr>
                      <td>{++index}</td>
                      <td>{value.key}</td>
                      <td>{value.subject}</td>
                      <td style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                      <Link className="btn btn-success custom-btn" to={{ pathname: "/admin/static-content-edit" }} state={{ id: value.get_static_content.id }} >
                        <i className="fas fa-edit" title="Edit"></i>
                      </Link>
                      </td>
                    </tr>
                  ))}  
                </tbody>
              </table>
            </div>     
          </div>
        </div>
    )
  }
  